<template>
  <v-app>
    <div v-if="isSpecialRoute()">
    </div>
    <div v-else-if="loading">
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>
    <div v-else>
      <div v-if="$route.name != 'custompage'">
        <div class="pb-0" v-if="!isSmallerDisplay()">
          <v-list-item>
            <v-list-item-avatar @click="goToHome()">
              <ImageDisplay :src="academy.image" alt="avatar" />
            </v-list-item-avatar>
            <v-list-item-content @click="goToHome()">
              <v-list-item-title>
                {{ academy.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ academy.city.name }}
                <country-display size="15" :country-code="academy.city.country" />
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn v-if="!isCheckinSection" large icon @click="navigateTo({ name: 'checkin' })">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn :disabled="$route.name === 'waiver'" text depressed color="primary" @click="launchWaiver">
                <v-icon>assignment</v-icon>
                {{ $t('message.waiver') }}
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn :disabled="$route.name === 'products'" text v-if="hasProducts" depressed color="primary"
                @click="launchProducts">
                <v-icon>shopping_cart</v-icon>
                {{ $t('message.store') }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
        <div v-else>
          <v-list-item>
            <v-list-item-avatar>
              <ImageDisplay :src="academy.image" alt="avatar" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ academy.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ academy.city.name }}
                <country-display size="15" :country-code="academy.city.country" />
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="!isCheckinSection">
              <v-btn large icon @click="navigateTo({ name: 'checkin' })">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn elevation="0" :disabled="$route.name === 'waiver'" class="pa-5" color="primary"
              @click="launchWaiver">
              <v-icon>assignment</v-icon>
              {{ $t('message.waiver') }}
            </v-btn>
            <v-btn elevation="0" :disabled="$route.name === 'products'" class="pa-5" v-if="hasProducts" color="primary"
              style="margin-left: 10px" @click="launchProducts">
              <v-icon>shopping_cart</v-icon>
              {{ $t('message.store') }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </div>
      </div>
    </div>
    <div width="100%" class="mt-2">
      <router-view />
    </div>
    <v-footer app v-if="!isSpecialRoute()">
      <v-btn v-if="$route.path == '/checkin'" icon @click="navigateTo({ name: 'staffcheckin' });">
        <v-icon>badge</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div @click="navigateTo({ name: 'checkin' })">&copy; BJJLINK LLC {{ new Date().getFullYear() }}</div>
      <v-spacer></v-spacer>
      <v-btn text @click="logout" v-if="isStaffSection">
        <v-icon class="mr-1">exit_to_app</v-icon>
        {{ $t('message.logout') }}
      </v-btn>
      <div v-else-if="appVersion">
        <v-btn elevation="0" text @click="reload()">
          v{{ appVersion }}
        </v-btn>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import CountryDisplay from '@/components/displays/CountryFlagDisplay.vue';
import Api from "@/services/Api";
import { Environment } from "@/services/Environment";

export default {
  name: 'App',
  components: {
    CountryDisplay
  },
  data() {
    return {
      loading: true,
      valid: true,
      hasProducts: false,
      academy: null,
      appVersion: Environment.get("VUE_APP_VERSION")
    }
  },
  created() {
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy + '/has/products')
      .then(response => {
        const data = response.data;
        if (data) {
          this.hasProducts = data.hasProducts;
        }
      });
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy)
      .then(response => {
        const data = response.data;
        if (data) {
          if (!data.active) {
            this.navigateTo({ name: 'inactiveaccount' });
            return;
          }
          this.academy = data;
          const preferredLanguage = data.preferredLanguage ? data.preferredLanguage.toLowerCase() : 'en';
          this.setLang(preferredLanguage);
          this.loading = false;
        }
      })
      .catch(e => {
        if (e) {
          console.log('Error: ', e);
        }
      })
  },
  methods: {
    isSpecialRoute() {
      if (this.$route.name == 'custompage' || this.$route.name == 'login' || this.$route.name?.indexOf('full-screen') >= 0)
        return true;
      return false;
    },
    goToHome() {
      let currentPage = this.$router && this.$router.history && this.$router.history.current ? this.$router.history.current.name : null;
      if (currentPage == 'checkin') {
        this.navigateTo({ name: 'staffcheckin' });
      } else {
        this.navigateTo({ name: 'checkin' });
      }
    },
    async reload() {
      const currentVersion = this.appVersion;
      const response = await Api()
        .get("utils/version/bjjlink-kiosk/latest?patch=true");
      const backendVersion = response.data;
      if (backendVersion && backendVersion.version && backendVersion.version != currentVersion) {
        console.log('Not current version[' + currentVersion + ' vs ' + backendVersion.version + ']! Reloading entire app');
        const url = new URL(window.location.href);
        url.searchParams.set('v', backendVersion.version);
        window.location.replace(url.toString());
      } else {
        window.location.reload(true);
      }
    },
    launchWaiver() {
      //console.log('scheduleClassId: ', this.selectedScheduleClassId)
      if (this.selectedScheduleClassId)
        this.navigateTo({ name: 'waiver', query: { scid: this.selectedScheduleClassId } });
      else if (this.selectedAcademyClassId)
        this.navigateTo({ name: 'waiver', query: { acid: this.selectedAcademyClassId } });
      else
        this.navigateTo({ name: 'waiver' });
    },
    launchProducts() {
      this.navigateTo({ name: 'products' });
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setTabletId", null);
      this.$store.dispatch("setTabletSelectedAcademy", null);
      this.$store.dispatch("setTabletManagedAcademy", null);
      localStorage.removeItem("tablet_token");
      window.location = 'login';
    }
  },
  computed: {
    isStaffSection() {
      const path = this.$route.path;
      if (path == "/staffcheckin") return true;
      return false;
    },
    isCheckinSection() {
      const path = this.$route.path;
      if (path == "/checkin") return true;
      return false;
    }
  }
};
</script>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons";


.supporting-text {
  color: gray;
  font-size: small;
}
</style>
